var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoRoundedPixel(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 165,
    height: 33,
    viewBox: "0 0 165 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_4_204)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 4,
    width: 21,
    height: 21,
    fill: "#FF3A6F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7019 9.912V13.818C14.7019 13.914 14.7559 13.962 14.8639 13.962H15.7639C17.8999 13.962 18.9679 13.2 18.9679 11.676C18.9679 10.32 17.9779 9.642 15.9979 9.642C15.6379 9.642 15.2599 9.672 14.8639 9.732C14.7559 9.756 14.7019 9.816 14.7019 9.912ZM13.2439 21C12.9679 21 12.7279 20.898 12.5239 20.694C12.3199 20.49 12.2179 20.25 12.2179 19.974V8.976C12.2179 8.688 12.3139 8.43 12.5059 8.202C12.6979 7.974 12.9379 7.848 13.2259 7.824C14.2459 7.728 15.2299 7.68 16.1779 7.68C17.9419 7.68 19.2619 8.01 20.1379 8.67C21.0139 9.318 21.4519 10.236 21.4519 11.424C21.4519 12.276 21.2179 13.026 20.7499 13.674C20.2939 14.322 19.6759 14.778 18.8959 15.042C18.8839 15.042 18.8779 15.048 18.8779 15.06C18.8779 15.084 18.8839 15.096 18.8959 15.096C19.4719 15.456 19.9639 16.164 20.3719 17.22L21.4519 20.046C21.5359 20.274 21.5059 20.49 21.3619 20.694C21.2299 20.898 21.0439 21 20.8039 21H20.2459C19.9339 21 19.6519 20.916 19.3999 20.748C19.1479 20.568 18.9679 20.334 18.8599 20.046L17.8519 17.274C17.6359 16.698 17.3899 16.32 17.1139 16.14C16.8379 15.96 16.3639 15.87 15.6919 15.87H14.8639C14.7559 15.87 14.7019 15.924 14.7019 16.032V19.974C14.7019 20.25 14.5999 20.49 14.3959 20.694C14.2039 20.898 13.9699 21 13.6939 21H13.2439Z",
    fill: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 4,
    width: 21,
    height: 21,
    rx: 2,
    fill: "#CA416B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.9166 14.43C41.9166 11.31 40.7766 9.75 38.4966 9.75C36.2166 9.75 35.0766 11.31 35.0766 14.43C35.0766 17.55 36.2166 19.11 38.4966 19.11C40.7766 19.11 41.9166 17.55 41.9166 14.43ZM42.8706 19.398C41.8026 20.586 40.3446 21.18 38.4966 21.18C36.6486 21.18 35.1846 20.586 34.1046 19.398C33.0366 18.21 32.5026 16.554 32.5026 14.43C32.5026 12.306 33.0366 10.65 34.1046 9.462C35.1846 8.274 36.6486 7.68 38.4966 7.68C40.3446 7.68 41.8026 8.274 42.8706 9.462C43.9506 10.65 44.4906 12.306 44.4906 14.43C44.4906 16.554 43.9506 18.21 42.8706 19.398Z",
    fill: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 4,
    width: 21,
    height: 21,
    rx: 4,
    fill: "#5B476C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.3624 16.32C65.3624 19.56 63.7424 21.18 60.5024 21.18C57.2624 21.18 55.6424 19.56 55.6424 16.32V8.886C55.6424 8.61 55.7444 8.37 55.9484 8.166C56.1524 7.962 56.3924 7.86 56.6684 7.86H57.1724C57.4484 7.86 57.6884 7.962 57.8924 8.166C58.0964 8.37 58.1984 8.61 58.1984 8.886V16.464C58.1984 17.4 58.3844 18.078 58.7564 18.498C59.1404 18.906 59.7344 19.11 60.5384 19.11C61.3424 19.11 61.9304 18.906 62.3024 18.498C62.6864 18.078 62.8784 17.4 62.8784 16.464V8.886C62.8784 8.61 62.9804 8.37 63.1844 8.166C63.3884 7.962 63.6284 7.86 63.9044 7.86H64.3364C64.6124 7.86 64.8524 7.962 65.0564 8.166C65.2604 8.37 65.3624 8.61 65.3624 8.886V16.32Z",
    fill: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 72,
    y: 4,
    width: 21,
    height: 21,
    rx: 6,
    fill: "#39678B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.5931 21C78.3171 21 78.0771 20.898 77.8731 20.694C77.6811 20.49 77.5851 20.25 77.5851 19.974V8.886C77.5851 8.61 77.6811 8.37 77.8731 8.166C78.0771 7.962 78.3171 7.86 78.5931 7.86H78.9891C79.6731 7.86 80.1771 8.16 80.5011 8.76L84.9471 16.788C84.9471 16.8 84.9531 16.806 84.9651 16.806C84.9771 16.806 84.9831 16.8 84.9831 16.788V8.886C84.9831 8.61 85.0851 8.37 85.2891 8.166C85.4931 7.962 85.7331 7.86 86.0091 7.86H86.4051C86.6811 7.86 86.9151 7.962 87.1071 8.166C87.3111 8.37 87.4131 8.61 87.4131 8.886V19.974C87.4131 20.25 87.3111 20.49 87.1071 20.694C86.9151 20.898 86.6811 21 86.4051 21H86.0091C85.3251 21 84.8211 20.7 84.4971 20.1L80.0511 12.072C80.0511 12.06 80.0451 12.054 80.0331 12.054C80.0211 12.054 80.0151 12.06 80.0151 12.072V19.974C80.0151 20.25 79.9131 20.49 79.7091 20.694C79.5051 20.898 79.2651 21 78.9891 21H78.5931Z",
    fill: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 94,
    y: 4,
    width: 21,
    height: 21,
    rx: 7,
    fill: "#4EB4E2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.307 9.948V18.912C102.307 18.996 102.355 19.05 102.451 19.074C102.835 19.134 103.195 19.164 103.531 19.164C104.935 19.164 105.967 18.786 106.627 18.03C107.287 17.262 107.617 16.002 107.617 14.25C107.617 12.678 107.281 11.526 106.609 10.794C105.937 10.062 104.911 9.696 103.531 9.696C103.195 9.696 102.835 9.726 102.451 9.786C102.355 9.81 102.307 9.864 102.307 9.948ZM100.831 21.054C100.531 21.018 100.285 20.892 100.093 20.676C99.9008 20.448 99.8048 20.184 99.8048 19.884V8.976C99.8048 8.676 99.9008 8.418 100.093 8.202C100.285 7.974 100.531 7.842 100.831 7.806C101.599 7.722 102.457 7.68 103.405 7.68C105.541 7.68 107.173 8.238 108.301 9.354C109.441 10.47 110.011 12.102 110.011 14.25C110.011 16.554 109.441 18.288 108.301 19.452C107.173 20.604 105.541 21.18 103.405 21.18C102.457 21.18 101.599 21.138 100.831 21.054Z",
    fill: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 116,
    y: 4,
    width: 21,
    height: 21,
    rx: 8,
    fill: "#CDDC39"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.534 21C123.258 21 123.018 20.898 122.814 20.694C122.61 20.49 122.508 20.25 122.508 19.974V8.886C122.508 8.61 122.61 8.37 122.814 8.166C123.018 7.962 123.258 7.86 123.534 7.86H129.654C129.93 7.86 130.17 7.962 130.374 8.166C130.578 8.37 130.68 8.61 130.68 8.886C130.68 9.162 130.578 9.402 130.374 9.606C130.17 9.798 129.93 9.894 129.654 9.894H125.19C125.082 9.894 125.028 9.948 125.028 10.056V12.954C125.028 13.062 125.082 13.116 125.19 13.116H129.348C129.624 13.116 129.852 13.212 130.032 13.404C130.224 13.596 130.32 13.824 130.32 14.088C130.32 14.352 130.224 14.58 130.032 14.772C129.852 14.952 129.624 15.042 129.348 15.042H125.19C125.082 15.042 125.028 15.096 125.028 15.204V18.804C125.028 18.912 125.082 18.966 125.19 18.966H129.654C129.93 18.966 130.17 19.068 130.374 19.272C130.578 19.464 130.68 19.698 130.68 19.974C130.68 20.25 130.578 20.49 130.374 20.694C130.17 20.898 129.93 21 129.654 21H123.534Z",
    fill: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 138,
    y: 4,
    width: 21,
    height: 21,
    rx: 10.5,
    fill: "#FFD089"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.307 9.948V18.912C146.307 18.996 146.355 19.05 146.451 19.074C146.835 19.134 147.195 19.164 147.531 19.164C148.935 19.164 149.967 18.786 150.627 18.03C151.287 17.262 151.617 16.002 151.617 14.25C151.617 12.678 151.281 11.526 150.609 10.794C149.937 10.062 148.911 9.696 147.531 9.696C147.195 9.696 146.835 9.726 146.451 9.786C146.355 9.81 146.307 9.864 146.307 9.948ZM144.831 21.054C144.531 21.018 144.285 20.892 144.093 20.676C143.901 20.448 143.805 20.184 143.805 19.884V8.976C143.805 8.676 143.901 8.418 144.093 8.202C144.285 7.974 144.531 7.842 144.831 7.806C145.599 7.722 146.457 7.68 147.405 7.68C149.541 7.68 151.173 8.238 152.301 9.354C153.441 10.47 154.011 12.102 154.011 14.25C154.011 16.554 153.441 18.288 152.301 19.452C151.173 20.604 149.541 21.18 147.405 21.18C146.457 21.18 145.599 21.138 144.831 21.054Z",
    fill: "#F4F4F4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_4_204",
    x: 0,
    y: 0,
    width: 165,
    height: 33,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4_204"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4_204",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoRoundedPixel);
export default __webpack_public_path__ + "static/media/logo-rounded-pixel.d29865f6.svg";
export { ForwardRef as ReactComponent };